export function ProductSkeleton() {
  return (
    <div className="bg-[#F9F7F1] rounded-3xl border-2 border-[#FF6B35]/20 flex flex-col overflow-hidden h-[480px] animate-pulse">
      <div className="relative overflow-hidden bg-gray-200 h-56 w-full" />
      <div className="flex-1 flex flex-col gap-2 p-5">
        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-full" />
        <div className="h-4 bg-gray-200 rounded w-5/6" />
        <div className="mt-auto flex flex-col gap-2">
          <div className="h-8 bg-gray-200 rounded w-1/3" />
          <div className="h-10 bg-gray-200 rounded w-full" />
        </div>
      </div>
    </div>
  );
}
